import React, { FormEvent, useState, useMemo, lazy, Suspense } from "react";
import { submitThought } from "../helpers/API";

interface LinkContent {
  url: string;
  title: string;
  description: string;
}

interface InputFormProps {
  date: string;
  fetchThoughts: () => void;
}

const defaultData = {
  time: 1556098174501,
  blocks: [
    {
      type: "paragraph",
      data: {
        text: "",
        level: 2,
      },
    },
  ],
};

const defaulPreviewData = {
  time: 1556098174501,
  blocks: [
    {
      type: "paragraph",
      data: {
        text: "",
        level: 2,
      },
    },
  ],
};

const InputForm: React.FC<InputFormProps> = ({ date, fetchThoughts }) => {
  const [type, setType] = useState<string>("link");
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [linkContent, setLinkContent] = useState<LinkContent>({
    url: "",
    title: "",
    description: "",
  });

  const Editor = useMemo(() => lazy(() => import("./Editor")), []);
  const [content, setContent] = useState<any>(defaultData);
  const [preview, setPreview] = useState<any>(defaulPreviewData);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // stringify content

    const thoughtContent = {
      date: date.toString(),
      caption: JSON.stringify(content),
      preview: JSON.stringify(preview),
      imageFile: imageFile,
      linkContent: linkContent,
    };

    const thoughtData = {
      type,
      content: thoughtContent,
    };

    await submitThought(thoughtData);
    fetchThoughts();
    setContent(defaultData);
    setPreview(defaulPreviewData);
    setImageFile(null);
  };

  return (
    <form className="input-form" onSubmit={handleSubmit}>
      <div className="radio-group">
        <label>
          <input
            type="radio"
            value="link"
            checked={type === "link"}
            onChange={(e) => setType(e.target.value)}
          />
          Link
        </label>
        <label>
          <input
            type="radio"
            value="image"
            checked={type === "image"}
            onChange={(e) => setType(e.target.value)}
          />
          Image
        </label>
        <label>
          <input
            type="radio"
            value="text"
            checked={type === "text"}
            onChange={(e) => setType(e.target.value)}
          />
          Text
        </label>
      </div>

      {type === "link" && (
        <div className="input-group">
          <label htmlFor="url">
            URL:
            <br />
            <input
              type="url"
              id="url"
              value={linkContent.url}
              onChange={(e) =>
                setLinkContent({ ...linkContent, url: e.target.value })
              }
            />
          </label>
          <label htmlFor="title">
            Title:
            <br />
            <input
              type="text"
              id="title"
              value={linkContent.title}
              onChange={(e) =>
                setLinkContent({ ...linkContent, title: e.target.value })
              }
            />
          </label>
          <label htmlFor="description">
            Description:
            <br />
            {/* <input
              type="text"
              id="description"
              value={linkContent.description}
              onChange={(e) =>
                setLinkContent({ ...linkContent, description: e.target.value })
              }
            /> */}
          </label>
          <label htmlFor="image">
            Image:
            <input
              type="file"
              id="image"
              accept="image/*"
              onChange={(e) =>
                setImageFile(e.target.files ? e.target.files[0] : null)
              }
            />
          </label>
          <br />
        </div>
      )}

      {type === "text" && (
        <div className="input-group">
          <label htmlFor="text">Content</label>
          <Suspense fallback={<div>LOADING</div>}>
            <Editor
              content={content}
              setContent={setContent}
              handleSubmit={handleSubmit}
              id="text-editor"
              placeholder={"Write something..."}
            />
          </Suspense>
          <label htmlFor="preview">Preview</label>
          <Suspense fallback={<div>LOADING</div>}>
            <Editor
              content={preview}
              setContent={setPreview}
              handleSubmit={handleSubmit}
              id="preview-editor"
              placeholder={"preview..."}
            />
          </Suspense>
        </div>
      )}

      {type === "image" && (
        <div className="input-group">
          <label htmlFor="image">Upload Image:</label>
          <input
            type="file"
            id="image"
            accept="image/*"
            onChange={(e) =>
              setImageFile(e.target.files ? e.target.files[0] : null)
            }
          />
          <label htmlFor="text">Text:</label>
          <Suspense fallback={<div>LOADING</div>}>
            <Editor
              content={content}
              setContent={setContent}
              handleSubmit={handleSubmit}
              placeholder={"Write something..."}
              id="text-editor"
            />
          </Suspense>
        </div>
      )}

      <button className="submit-button" type="submit">
        Submit
      </button>
    </form>
  );
};

export default InputForm;
